import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import LogoSpinner from '../../../components/LogoSpinner/LogoSpinner';
import Sidebar, { SIDEBAR_WIDTH_COMPACT, SIDEBAR_WIDTH_EXPANDED } from './Sidebar';

const PageWrapper = () => {
	const theme = useTheme();
	const isCompact = useMediaQuery(theme.breakpoints.down('md'));
	const sidebarWidth = isCompact ? SIDEBAR_WIDTH_COMPACT : SIDEBAR_WIDTH_EXPANDED;

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh' }}>
			<CssBaseline />
			<Sidebar />
			<Box 
				component="main" 
				sx={{ 
					flexGrow: 1, 
					marginLeft: `${sidebarWidth}px`,
					width: `calc(100% - ${sidebarWidth}px)`,
					minHeight: '100vh',
					display: 'flex',
					flexDirection: 'column',
					transition: 'margin-left 0.3s ease, width 0.3s ease',
					overflow: 'hidden',
				}}
			>
				{/* Keep sidebar mounted while lazy route chunks load (avoids full-app Suspense blank). */}
				<Suspense fallback={<LogoSpinner size={40} minHeight="50vh" />}>
					<Outlet />
				</Suspense>
			</Box>
		</Box>
	);
};

export default PageWrapper;